import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    acnoInfo: {},
    checked: [],
    RBF0107K10: {
      request: {},
      response: {},
      dataGrid: [],
      nextPaymtzYmd: "",
      totalLineCnt: "",
      divisionLineCnt: "",
    },
    RBF0407D40: {
      pre1: {
        request: {},
        response: {},
      },
      pre2: {
        request: {},
        response: {},
      },
    },
    RBF0107C10: {
      request: {},
      response: {},
    },
  };
};

const interestLoanPayment = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getAcnoInfo: state => {
      return state.acnoInfo;
    },
    getChecked: state => {
      return state.checked;
    },
    getRBF0107K10: state => {
      return state.RBF0107K10;
    },
    getRBF0407D40: state => {
      return state.RBF0407D40;
    },
    getRBF0107C10: state => {
      return state.RBF0107C10;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setAcnoInfo: (state, obj) => {
      state.acnoInfo = obj;
    },
    setChecked: (state, obj) => {
      state.checked = obj;
    },
    setRBF0107K10: (state, obj) => {
      state.RBF0107K10 = obj;
    },
    setRBF0407D40: (state, obj) => {
      state.RBF0407D40 = obj;
    },
    setRBF0107C10: (state, obj) => {
      state.RBF0107C10 = obj;
    },
  },
  actions: {
    actSetAcnoInfo: (context, payload) => {
      context.commit("setAcnoInfo", payload);
    },
    actSetChecked: (context, payload) => {
      context.commit("setChecked", payload);
    },
    actSetRBF0107K10: (context, payload) => {
      context.commit("setRBF0107K10", payload);
    },
    actSetRBF0407D40: (context, payload) => {
      context.commit("setRBF0407D40", payload);
    },
    actSetRBF0107C10: (context, payload) => {
      context.commit("setRBF0107C10", payload);
    },
  },
};

export default interestLoanPayment;
